module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"th":{"customer_modal.search.placeholder":"ค้นหาลูกค้า (ชื่อ, เบอร์โทร)","customer_modal.add.label":"เพิ่มลูกค้าใหม่","customer.new.button":"เพิ่มลูกค้า","customer.new.cancel":"ย้อนกลับ","customer.new.title":"เพิ่มลูกค้าใหม่","customer_modal.select.label":"เลือก","customer_modal.unselect.label":"ยกเลิก","customer_modal.title":"เลือกลูกค้า"}}')
  delete Component.options._Ctor
}
